<article class="lum-page lum-page__card lum-c-custom-field">
  <div
    class="overlay"
    lumAppLoader
    [loading]="loading"
    [classes]="'loading blur'"
  ></div>

  <header class="lum-page-header lum-page-header--sticky">
    <h2 class="lum-page-header__heading">Custom Fields</h2>
    <div class="lum-page-header__actions">
      <lum-custom-field-create></lum-custom-field-create>
    </div>
  </header>

  <div class="lum-page-content">
    <lum-custom-field-filters
      class="mb-2"
      (searchEvent)="onSearchEvent($event)"
    ></lum-custom-field-filters>

    <ng-container *ngIf="loading === false">
      <lum-custom-field-table
        *ngIf="data?.length; else empty"
        (deleteEvent)="onDeleteEvent($event)"
        [data]="data"
      ></lum-custom-field-table>
      <mat-paginator
        [length]="pagination.total || 0"
        [pageSize]="pagination.per_page || paginationConfig.perPage"
        [pageSizeOptions]="paginationConfig.pageSizeOptions"
        [pageIndex]="(pagination.current_page || 1) - 1"
        aria-label="Select page"
        class="lum-paging lum-paging--dodge-back-to-top lum-paging--sticky"
        (page)="onPaginationEvent($event)"
      >
      </mat-paginator>
    </ng-container>

    <ng-template #empty>
      <lum-ui-empty-page title="No records available."></lum-ui-empty-page>
    </ng-template>
  </div>
</article>
